import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { isAnswerCorrect } from 'src/app/quiz/config/quiz';
import { MultipleChoiceQuestion } from 'src/app/quiz/models/quiz-question.model';

@Component({
  selector: 'app-view-quiz-multiple-choice-answer',
  templateUrl: './view-quiz-multiple-choice-answer.component.html',
  styleUrls: ['./view-quiz-multiple-choice-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewQuizMultipleChoiceAnswerComponent implements OnInit {

  @Input()
  question: MultipleChoiceQuestion;

  @Input()
  answer: string[];

  @Input()
  summary: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  isOptionAnswerCorrect(question: MultipleChoiceQuestion, selectedAnswer: string, correctAnswer: string[]) {
    const isCorrect = isAnswerCorrect(question, [selectedAnswer]);
    return (selectedAnswer === correctAnswer[0] || isCorrect)
      ? isCorrect
      : undefined;
  }

}
